import { setSuccessNotification, setErrorNotification } from '../../reducers/notificationReducer'

export const copyText = async ({ dispatch, text, successMessage, errorMessage }) => {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text)
        } else {
            const textArea = document.createElement('textarea')
            textArea.value = text
            textArea.style.position = 'fixed'
            textArea.style.left = '-9999px'
            textArea.style.top = '0'
            document.body.appendChild(textArea)
            textArea.select()
            const copied = document.execCommand('copy')
            document.body.removeChild(textArea)
            if (!copied) throw new Error('Copy command failed')
        }
        dispatch(setSuccessNotification(successMessage))
    } catch (error) {
        dispatch(setErrorNotification(errorMessage))
    }
}

export const copyResourceLink = ({ dispatch, resourcePath, resourceId }) => copyText({
    dispatch,
    text: `${window.location.origin}/${resourcePath}/${resourceId}`,
    successMessage: 'Link copied to clipboard',
    errorMessage: 'Unable to copy link. Please copy the URL manually.',
})
